/* ============================================================
   DarthBot — chat widget
   Self-mounting browser widget. POSTs to Netlify proxy.
   Single file. No build step. No external dependencies.
   ============================================================ */

(function () {
  'use strict';

  if (window.__ddChatMounted) return;
  window.__ddChatMounted = true;

  // ---------- Config ----------
  var PROXY_URL = 'https://darthdabs-chat.netlify.app/api/chat';
  var STORAGE_KEY = 'dd_chat_history_v1';
  var MAX_HISTORY = 20;
  var WELCOME = "Hi, I'm DarthBot \u2014 ask me about American heady glass, our artists, or any piece on the wall.";

  // ---------- State ----------
  var messages = [];
  var isOpen = false;
  var isLoading = false;

  try {
    var saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) messages = JSON.parse(saved);
  } catch (e) { /* ignore */ }

  // ---------- CSS ----------
  var css = [
    '.dd-chat-root{font-family:"Jost",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}',
    '.dd-chat-bubble{position:fixed;bottom:20px;left:20px;width:60px;height:60px;border-radius:50%;background:#ff2e2e;color:#fff;border:0;cursor:pointer;z-index:10000;display:grid;place-items:center;box-shadow:0 8px 24px rgba(0,0,0,0.4),0 0 0 1px rgba(201,168,76,0.2);transition:transform 200ms cubic-bezier(0.22,1,0.36,1),box-shadow 200ms,background 200ms;}',
    '.dd-chat-bubble:hover{transform:translateY(-2px) scale(1.05);box-shadow:0 12px 32px rgba(0,0,0,0.5),0 0 0 1px rgba(201,168,76,0.4);}',
    '.dd-chat-bubble svg{width:26px;height:26px;}',
    '.dd-chat-bubble[data-open="true"]{background:#1a1a1a;border:1px solid #c9a84c;}',
    '.dd-chat-panel{position:fixed;bottom:96px;left:20px;width:380px;max-width:calc(100vw - 40px);height:540px;max-height:calc(100vh - 120px);background:#0f0f10;border:1px solid #c9a84c;border-radius:12px;z-index:10001;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 24px 60px rgba(0,0,0,0.6);opacity:0;transform:translateY(8px) scale(0.98);transition:opacity 200ms,transform 200ms cubic-bezier(0.22,1,0.36,1);pointer-events:none;}',
    '.dd-chat-panel[data-open="true"]{opacity:1;transform:translateY(0) scale(1);pointer-events:auto;}',
    '.dd-chat-header{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #222;background:linear-gradient(180deg,#161617 0%,#0f0f10 100%);flex-shrink:0;}',
    '.dd-chat-header__title{display:flex;flex-direction:column;gap:2px;}',
    '.dd-chat-brand{font-family:"Cinzel",Georgia,serif;font-weight:700;font-size:16px;letter-spacing:0.18em;color:#ff2e2e;text-transform:uppercase;}',
    '.dd-chat-est{font-family:"Bebas Neue","Helvetica Neue",Arial,sans-serif;font-size:10px;letter-spacing:0.24em;color:#c9a84c;}',
    '.dd-chat-close{background:transparent;border:0;color:#a39d92;font-size:24px;line-height:1;width:32px;height:32px;cursor:pointer;border-radius:999px;display:grid;place-items:center;transition:color 140ms,background 140ms;}',
    '.dd-chat-close:hover{color:#c9a84c;background:rgba(255,255,255,0.04);}',
    '.dd-chat-messages{flex:1;overflow-y:auto;padding:16px 16px 8px 16px;display:flex;flex-direction:column;gap:10px;scrollbar-width:thin;scrollbar-color:#2a2a2a transparent;}',
    '.dd-chat-messages::-webkit-scrollbar{width:6px;}',
    '.dd-chat-messages::-webkit-scrollbar-thumb{background:#2a2a2a;border-radius:3px;}',
    '.dd-chat-msg{max-width:84%;padding:10px 14px;border-radius:14px;font-size:14px;line-height:1.5;word-wrap:break-word;animation:dd-chat-fade-in 200ms cubic-bezier(0.22,1,0.36,1);}',
    '@keyframes dd-chat-fade-in{from{opacity:0;transform:translateY(4px);}to{opacity:1;transform:translateY(0);}}',
    '.dd-chat-msg--user{align-self:flex-end;background:#ff2e2e;color:#fff;border-bottom-right-radius:4px;}',
    '.dd-chat-msg--bot{align-self:flex-start;background:#161617;color:#ede9e1;border:1px solid #222;border-bottom-left-radius:4px;}',
    '.dd-chat-msg--bot a{color:#c9a84c;text-decoration:underline;}',
    '.dd-chat-typing{align-self:flex-start;padding:12px 14px;background:#161617;border:1px solid #222;border-radius:14px;border-bottom-left-radius:4px;display:inline-flex;gap:4px;align-items:center;}',
    '.dd-chat-typing span{width:6px;height:6px;background:#a39d92;border-radius:50%;animation:dd-chat-bounce 1.4s infinite ease-in-out both;}',
    '.dd-chat-typing span:nth-child(2){animation-delay:160ms;}',
    '.dd-chat-typing span:nth-child(3){animation-delay:320ms;}',
    '@keyframes dd-chat-bounce{0%,80%,100%{transform:scale(0.6);opacity:0.4;}40%{transform:scale(1);opacity:1;}}',
    '.dd-chat-form{display:flex;gap:8px;padding:12px 16px;border-top:1px solid #222;background:#0f0f10;flex-shrink:0;}',
    '.dd-chat-input{flex:1;min-height:40px;padding:8px 12px;background:#161617;border:1px solid #222;border-radius:8px;color:#ede9e1;font-family:inherit;font-size:14px;transition:border-color 140ms;}',
    '.dd-chat-input:focus{outline:none;border-color:#c9a84c;}',
    '.dd-chat-input::placeholder{color:#6e6860;}',
    '.dd-chat-send{padding:0 16px;background:#ff2e2e;color:#fff;border:0;border-radius:8px;font-family:inherit;font-size:12px;font-weight:600;letter-spacing:0.14em;text-transform:uppercase;cursor:pointer;transition:background 140ms,opacity 140ms;}',
    '.dd-chat-send:hover{background:#c91f1f;}',
    '.dd-chat-send:disabled{opacity:0.5;cursor:not-allowed;}',
    '@media (max-width:480px){.dd-chat-bubble{bottom:16px;left:16px;}.dd-chat-panel{bottom:0;left:0;width:100vw;max-width:100vw;height:100vh;max-height:100vh;border-radius:0;border:0;border-top:1px solid #c9a84c;}}',
    '@media (prefers-reduced-motion:reduce){.dd-chat-bubble,.dd-chat-panel,.dd-chat-msg,.dd-chat-typing span{animation:none !important;transition:none !important;}}'
  ].join('');

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ---------- DOM ----------
  var root = document.createElement('div');
  root.className = 'dd-chat-root';
  root.innerHTML = [
    '<button class="dd-chat-bubble" type="button" aria-label="Open DarthBot chat" data-dd-chat-toggle>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">',
        '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
      '</svg>',
    '</button>',
    '<div class="dd-chat-panel" role="dialog" aria-label="DarthBot chat" data-dd-chat-panel>',
      '<header class="dd-chat-header">',
        '<div class="dd-chat-header__title">',
          '<span class="dd-chat-brand">DarthBot</span>',
          '<span class="dd-chat-est">EST. 2016</span>',
        '</div>',
        '<button class="dd-chat-close" type="button" aria-label="Close chat" data-dd-chat-toggle>&times;</button>',
      '</header>',
      '<div class="dd-chat-messages" data-dd-chat-messages aria-live="polite"></div>',
      '<form class="dd-chat-form" data-dd-chat-form>',
        '<input class="dd-chat-input" type="text" placeholder="Ask about pieces, artists, dabbing\u2026" autocomplete="off" maxlength="500" aria-label="Your message" data-dd-chat-input>',
        '<button class="dd-chat-send" type="submit" data-dd-chat-send>Send</button>',
      '</form>',
    '</div>'
  ].join('');
  document.body.appendChild(root);

  // ---------- Refs ----------
  var bubble     = root.querySelector('.dd-chat-bubble');
  var panel      = root.querySelector('[data-dd-chat-panel]');
  var messagesEl = root.querySelector('[data-dd-chat-messages]');
  var form       = root.querySelector('[data-dd-chat-form]');
  var input      = root.querySelector('[data-dd-chat-input]');
  var sendBtn    = root.querySelector('[data-dd-chat-send]');

  // ---------- Render helpers ----------
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function linkify(s) {
    var out = escapeHtml(s);
    out = out.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    out = out.replace(/(^|[^"=>])(https?:\/\/[^\s<]+)/g, '$1<a href="$2" target="_blank" rel="noopener">$2</a>');
    return out.replace(/\n/g, '<br>');
  }

  function renderMessages() {
    var html = '';
    if (messages.length === 0) {
      html = '<div class="dd-chat-msg dd-chat-msg--bot">' + escapeHtml(WELCOME) + '</div>';
    } else {
      for (var i = 0; i < messages.length; i++) {
        var m = messages[i];
        var cls = m.role === 'user' ? 'dd-chat-msg--user' : 'dd-chat-msg--bot';
        html += '<div class="dd-chat-msg ' + cls + '">' + linkify(m.content) + '</div>';
      }
    }
    if (isLoading) {
      html += '<div class="dd-chat-typing"><span></span><span></span><span></span></div>';
    }
    messagesEl.innerHTML = html;
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function persist() {
    try {
      var trimmed = messages.slice(-MAX_HISTORY * 2);
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    } catch (e) { /* quota */ }
  }

  // ---------- API ----------
  function send(text) {
    messages.push({ role: 'user', content: text });
    isLoading = true;
    sendBtn.disabled = true;
    renderMessages();
    persist();

    fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: messages.slice(-MAX_HISTORY * 2) })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('proxy ' + res.status);
      return res.json();
    })
    .then(function (data) {
      var reply = data.content
               || data.message
               || data.reply
               || (data.choices && data.choices[0] && data.choices[0].message && data.choices[0].message.content)
               || '';
      if (!reply) throw new Error('empty reply');
      messages.push({ role: 'assistant', content: reply });
    })
    .catch(function () {
      messages.push({
        role: 'assistant',
        content: "Sorry \u2014 couldn't reach the gallery. Try again in a moment, or browse [the homepage](https://darthdabs.com) directly."
      });
    })
    .then(function () {
      isLoading = false;
      sendBtn.disabled = false;
      renderMessages();
      persist();
    });
  }

  // ---------- Toggle ----------
  function toggle(force) {
    isOpen = typeof force === 'boolean' ? force : !isOpen;
    bubble.dataset.open = isOpen ? 'true' : 'false';
    panel.dataset.open  = isOpen ? 'true' : 'false';
    if (isOpen) {
      renderMessages();
      setTimeout(function () { input.focus(); }, 100);
    }
  }

  // ---------- Events ----------
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-dd-chat-toggle]')) toggle();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text || isLoading) return;
    input.value = '';
    send(text);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) toggle(false);
  });

  // ---------- Init ----------
  renderMessages();
})();
